import CountItemSelected from 'views/molecules/CountItemSelected/CountItemSelected';

export default CountItemSelected;
